import { Route, Routes, Navigate } from 'react-router-dom';
import { ROUTES } from './routes.ts';
import HomePage from '../pages/home/page.tsx';
import MatchSKUPage from '../pages/competitor/match-sku/page.tsx';
import MatchStatusPage from '../pages/competitor/match-status/page.tsx';
import LoginPage from '../pages/login/page.tsx';
import ManualPage from '../pages/manual/page.tsx';
import AgentRegistryPage from '../pages/agent-registry/page.tsx';
import OrdersPage from '../pages/oms/orders/page.tsx';
import { OrderDetailPage } from '../pages/oms/orders/[id]/page.tsx';
import AuditPage from '../pages/oms/orders/[id]/audit/page.tsx';
import FulfillmentStatusPage from '../pages/oms/fulfillment/page.tsx';
import Layout from '../components/layout/Layout.tsx';
import ProtectedRoute from '../components/auth/ProtectedRoute.tsx';
import DeliveryTracePage from '../pages/oms/orders/[id]/trace/page.tsx';
import BannerUploadPage from '../pages/site-management/banner/upload/page.tsx';
import BannerListPage from '../pages/site-management/banner/list/page.tsx';
import MatchingPage from '../pages/sourcing/matching/page.tsx';
import MatchedProductsPage from '../pages/sourcing/matched/page.tsx';
import MatchedProductDetailPage from '../pages/sourcing/matched/[cpProductId]/page.tsx';
import ImageEditorPage from '../pages/sourcing/matched/[cpProductId]/image-editor/page.tsx';
import MatchedGpiPage from '../pages/sourcing/matched-gpi/page.tsx';
import SSCPRematchingPage from '../pages/sourcing/ss-cp-rematching/page.tsx';
import ReviewPage from '../pages/review/page.tsx';
import SiteCacheManagementPage from '../pages/site-management/cache/page.tsx';
import CampaignPage from '../pages/site-management/campaign/page.tsx';
import ShippingPage from '../pages/site-management/shipping/page.tsx';
import CronJobPage from '../pages/system/cron-jobs/page.tsx';
import RedirectConfigurationPage from '../pages/system/redirect-configuration/page.tsx';
import IngredientPage from '../pages/category/ingredient/page.tsx';
import ScrapeBatchPage from '../pages/sourcing/scrape-batch/page.tsx';
import WMSViewOrdersPage from '../pages/oms/wms/view-orders/page.tsx';
import WMSStockPage from '../pages/oms/wms/stock/page.tsx';
import ReadyToBeOutbondedPage from '../pages/oms/wms/stock/readyToBeOutbonded/page.tsx';
import LoyaltyPage from '../pages/customer/loyalty/page.tsx';
import TierManagementPage from '../pages/customer/loyalty/tier-management/page.tsx';
import SSEditorPage from '../pages/catalog/ss-editor/page.tsx';
import CMWorkflowPage from '../pages/catalog/cm-workflow/page.tsx';

const Router = () => {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<LoginPage />} />

      {/* Protected routes */}
      <Route
        path={ROUTES.home}
        element={
          <ProtectedRoute>
            <Layout>
              <HomePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.competitor.matchSKU.default}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchSKUPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.competitor.matchStatus}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchStatusPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ai.manual}
        element={
          <ProtectedRoute>
            <Layout>
              <ManualPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ai.agentRegistry}
        element={
          <ProtectedRoute>
            <Layout>
              <AgentRegistryPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.orders}
        element={
          <ProtectedRoute>
            <Layout>
              <OrdersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.fulfillment}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentStatusPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.oms.orders}/:id/trace/:trackingNo`}
        element={
          <ProtectedRoute>
            <Layout>
              <DeliveryTracePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.oms.orders}/:id/audit`}
        element={
          <ProtectedRoute>
            <Layout>
              <AuditPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.oms.orders}/:id`}
        element={
          <ProtectedRoute>
            <Layout>
              <OrderDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.wms.viewOrders}
        element={
          <ProtectedRoute>
            <Layout>
              <WMSViewOrdersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.wms.stock}
        element={
          <ProtectedRoute>
            <Layout>
              <WMSStockPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.wms.readyToBeOutbonded}
        element={
          <ProtectedRoute>
            <Layout>
              <ReadyToBeOutbondedPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.banner.upload}
        element={
          <ProtectedRoute>
            <Layout>
              <BannerUploadPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.banner.list}
        element={
          <ProtectedRoute>
            <Layout>
              <BannerListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.default}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/glowpickId/:glowpickId"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/brand/:brand"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/category/:category/subcategory/:subcategory"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/category/:category"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.matching}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/:cpProductId/:cpItemId/image-editor/:tab?"
        element={
          <ProtectedRoute>
            <Layout>
              <ImageEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/:cpProductId/:cpItemId"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.matched}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/category/:category/subcategory/:subcategory"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/category/:category"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/gpi/:gpi"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedGpiPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.ssReMatching}
        element={
          <ProtectedRoute>
            <Layout>
              <SSCPRematchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.review.default}
        element={
          <ProtectedRoute>
            <Layout>
              <ReviewPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.siteManagement.cache}
        element={
          <ProtectedRoute>
            <Layout>
              <SiteCacheManagementPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.siteManagement.campaigns}
        element={
          <ProtectedRoute>
            <Layout>
              <CampaignPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.siteManagement.shipping}
        element={
          <ProtectedRoute>
            <Layout>
              <ShippingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.systemManagement.cronJobs}
        element={
          <ProtectedRoute>
            <Layout>
              <CronJobPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.systemManagement.redirectConfiguration}
        element={
          <ProtectedRoute>
            <Layout>
              <RedirectConfigurationPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.category.ingredient.default}
        element={
          <ProtectedRoute>
            <Layout>
              <IngredientPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.catalog.ssEditor}
        element={
          <ProtectedRoute>
            <Layout>
              <SSEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/ss-editor/sku/:sku"
        element={
          <ProtectedRoute>
            <Layout>
              <SSEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.scrapeBatch}
        element={
          <ProtectedRoute>
            <Layout>
              <ScrapeBatchPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.catalog.cmWorkflow}
        element={
          <ProtectedRoute>
            <Layout>
              <CMWorkflowPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.loyalty}
        element={
          <ProtectedRoute>
            <Layout>
              <LoyaltyPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.tierManagement}
        element={
          <ProtectedRoute>
            <Layout>
              <TierManagementPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Redirect to home if route doesn't match */}
      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  );
};

export default Router;
